import { organisationUserActions } from './reducers';

export const {
  getCurrentOrganisationUserAction,
  setCurrentOrganisationUserAction,
  setOrganisationUserErrorAction,
  clearCurrentOrganisationUserAction,
} = organisationUserActions;
